export enum FilterPredicateEnum {
        Equals = 0,
        NotEqual = 1,
        GreaterThan = 2,
        GreaterThanEqual = 3,
        LesserThan = 4,
        LesserThanOrEqual = 5,
        Contains = 6,
  }
